/**
 * The one card a player shares: 9:16, with its stats kept inside the centre
 * 4:5 band, so a story shows it whole and a feed's crop still shows all of
 * it. Behind the stats is nothing, or the player's own photo.
 */

export interface CardSize {
    width: number;
    height: number;
}

export const CARD_SIZE: CardSize = { width: 1080, height: 1920 };
